import { render } from "./mentalHealthVideo.vue?vue&type=template&id=cd5d70f2&scoped=true"
import script from "./mentalHealthVideo.vue?vue&type=script&lang=js"
export * from "./mentalHealthVideo.vue?vue&type=script&lang=js"

import "./mentalHealthVideo.vue?vue&type=style&index=0&id=cd5d70f2&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd5d70f2"]])

export default __exports__